'use strict';

angular.module('app')
  .service('GTM', function () {
    var GTM = {};

    if (!angular.isArray(window.dataLayer)) {
        window.dataLayer = [];
    }

    GTM.event = function (event) {
      if (angular.isArray(event)) {

        _.each(event, function(val) {
          window.dataLayer.push({'event': val});
        });

        return true;
      }

      return window.dataLayer.push({'event': event});
    };

    GTM.variables = function (variable) {
       return window.dataLayer.push(variable);
    };

    GTM.clickTrack = function (ev) {
        console.log(ev);

      if (ev) {
        GTM.event(ev);
      }
    };

    GTM.products = function(event, ecommerce) {
      var obj = {'ecommerce':  ecommerce}

      if (event) {
        obj.event = event;
      }
      
      return window.dataLayer.push(obj);
    };

    return GTM;

  });
